export function smoothScroll(): void {
  $('.js-smooth-scroll').click(function(){
    const adjust = -80;
    const speed = 400;
    const href= $(this).attr("href");
    const target = $(href == "#" || href == "" ? 'html' : href);
    const position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
}
